import { render } from "./team-list.vue?vue&type=template&id=36e94890&scoped=true"
import script from "./team-list.vue?vue&type=script&lang=js"
export * from "./team-list.vue?vue&type=script&lang=js"

import "./team-list.vue?vue&type=style&index=0&id=36e94890&scoped=true&lang=css"
import "./team-list.vue?vue&type=style&index=1&id=36e94890&lang=css"

import exportComponent from "/var/lib/buildkite-agent/builds/BKxAWS-i-01d4bca84f43bee68-1/assemble-sports/aucklandrugbyleague-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e94890"]])

export default __exports__